import { Box, Tab, useTheme } from '@mui/material';
import { useState } from 'react';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { boxContainerSx } from '../../styles/Global.style';
import { tabContainerSx, tabPanelSx, tabSx } from './TabBar.style';

export const TabBar = ({ tabs, sx }) => {
  const theme = useTheme();
  const [value, setValue] = useState('1');

  const handleChange = (e, newValue) => {
    e.preventDefault();
    setValue(newValue);
  };

  return (
    <Box sx={{ ...boxContainerSx, ...sx }}>
      <TabContext value={value}>
        <Box sx={tabContainerSx(theme)}>
          <TabList onChange={handleChange}>
            {tabs.map((tab, i) => (
              <Tab
                key={`tab-${i + 1}`}
                icon={tab.icon}
                label={tab.label}
                value={(i + 1).toString()}
                sx={tabSx(theme)}
              />
            ))}
          </TabList>
        </Box>

        {tabs.map((tab, i) => (
          <TabPanel
            key={`tab-panel-${i + 1}`}
            value={(i + 1).toString()}
            sx={tabPanelSx(theme)}
          >
            {tab.content}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};
